import { connect } from 'react-redux';
import ZohoConfigurationView from './ZohoConfigurationView.jsx';
import { updateConfiguration} from 'src/legacy/redux/actions/integrations/zoho.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    errors: state.legacyRootReducer.settings.integrations.zoho.changes.error,
    updating: state.legacyRootReducer.settings.integrations.zoho.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.zoho.changes.loading,
    user: state.users.me,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    }
  }
}

const ZohoConfigurationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(ZohoConfigurationView);

export default ZohoConfigurationPage;
